import _ from 'lodash';

/**
 * Properties on the enrichment data entity which NOT will be included in the
 * copy.
 *
 * @type {Array}
 */
const propsToOmit = [
  'id',
  'referencedIngredientData',
  'modifyDate',
  'luanchDate',
  'lastModifiedBy',
  'createdBy',
  'version',
  'hash',
  'parentPpiEnrichmentDataId',
  'parentPpiId',
  'enrichmentStatus',
  'targetPublishDate',
  'targetUnpublishDate',
  'actualPublishedDate',
  'publishBy',
  'isUpToDate',
  'upToDate',
  'updateNotificationList',
  'compliantIfsPpiToEnrichmentDataIds'
];

/**
 * Translations on the enrichment data entity which NOT will be included in the
 * copy.
 *
 * @type {Array}
 */

function copyTranslations(forPath, toLanguages) {
  const { info } = forPath;
  toLanguages.forEach(toLanguage => {
    info[toLanguage].versionComment = null;
  });
  return info;
}

function copyPrepAndProdSteps(fromEnrichment) {
  return fromEnrichment.prepAndProdSteps.map(step => {
    const stepDetails = step.stepDetails.map(detail => {
      return {
        ...detail,
        id: null
      };
    });
    return {
      ...step,
      id: null,
      key: `id-${Math.round(Math.random() * 1000000)}`,
      stepDetails
    };
  });
}

function copyEnrichmentData(fromEnrichment, toLanguages) {
  const data = _.omit(fromEnrichment, propsToOmit);
  data.info = copyTranslations(data, toLanguages);
  data.prepAndProdSteps = copyPrepAndProdSteps(fromEnrichment);
  return data;
}

function copyPublishedPpi(fromPpi, fromEnrichmentId, toLanguages) {
  let enrichmentData;
  if (_.get(fromPpi, 'publishedPPIEnrichmentData.id') === fromEnrichmentId) {
    enrichmentData = fromPpi.publishedPPIEnrichmentData;
  }
  if (!enrichmentData) {
    throw new Error(
      `Failed to locate PPI Enrichment Data to base PPI on (from enrichment with id: ${fromEnrichmentId})`
    );
  }
  return copyEnrichmentData(enrichmentData, toLanguages);
}

export default copyPublishedPpi;
